var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      ref: "form",
      staticClass: "banner_service_config",
      attrs: {
        model: _vm.value.config,
        rules: _vm.rules,
        disabled: _vm.disabled,
      },
    },
    [
      _c("div", { staticClass: "tips" }, [
        _vm._v(" 点击组件图片，会将配置的客服电话带上跳转手机拨号软件 "),
      ]),
      _c("el-form-item", { attrs: { prop: "image" } }, [
        _c("div", { staticClass: "label" }, [_vm._v("组件图片")]),
        _c("div", { staticClass: "box" }, [
          _c("div", { staticClass: "upload-item-wrap" }, [
            _c(
              "div",
              { staticClass: "left" },
              [
                _c("upload-file", {
                  ref: "uploadBanner",
                  attrs: {
                    "link-url": _vm.linkUrl,
                    tempurl: _vm.value.config.image,
                    canDel: Boolean(_vm.value.config.image),
                    deletePadding: true,
                    uploadInfo: _vm.uploadInfo,
                  },
                  on: {
                    onDelete: _vm.deleteImg,
                    emitUploadFile: _vm.emitUploadFile,
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "right" },
              [
                _c("el-button", { on: { click: _vm.onUpload } }, [
                  _vm._v("上传图片"),
                ]),
                _vm.pictureList.length > 0
                  ? _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.selectPicture },
                      },
                      [_vm._v("选择图片")]
                    )
                  : _vm._e(),
              ],
              1
            ),
          ]),
        ]),
      ]),
      _c(
        "el-form-item",
        { attrs: { prop: "service_hotline_source" } },
        [
          _c("div", { staticClass: "label" }, [_vm._v("客服电话")]),
          _c(
            "el-radio-group",
            {
              model: {
                value: _vm.value.config.service_hotline_source,
                callback: function ($$v) {
                  _vm.$set(_vm.value.config, "service_hotline_source", $$v)
                },
                expression: "value.config.service_hotline_source",
              },
            },
            [
              _c(
                "div",
                { staticClass: "radio-box" },
                [
                  _c("el-radio", { attrs: { label: "1" } }, [
                    _vm._v(
                      " 取渠道基本信息客服电话 " +
                        _vm._s(
                          _vm.channel_service_hotline
                            ? "(" + _vm.channel_service_hotline + ")"
                            : ""
                        ) +
                        " "
                    ),
                  ]),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "radio-box" },
                [
                  _c("el-radio", { attrs: { label: "2" } }, [
                    _vm._v("单独填写"),
                  ]),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
      _vm.value.config.service_hotline_source === "2"
        ? _c(
            "el-form-item",
            { key: "service_hotline", attrs: { prop: "service_hotline" } },
            [
              _c("el-input", {
                attrs: { placeholder: "请输入客服电话", clearable: "" },
                model: {
                  value: _vm.value.config.service_hotline,
                  callback: function ($$v) {
                    _vm.$set(_vm.value.config, "service_hotline", $$v)
                  },
                  expression: "value.config.service_hotline",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _c(
        "el-form-item",
        {
          staticClass: "margin_top",
          attrs: {
            prop: "margin_top",
            rules: [{ type: "number", message: "间距必须为数字值" }],
          },
        },
        [
          _c("div", [_vm._v(" 与上方组件的间距 ")]),
          _c("el-input", {
            attrs: { placeholder: "请输入间距", clearable: "" },
            model: {
              value: _vm.value.config.margin_top,
              callback: function ($$v) {
                _vm.$set(_vm.value.config, "margin_top", _vm._n($$v))
              },
              expression: "value.config.margin_top",
            },
          }),
        ],
        1
      ),
      _c(
        "el-form-item",
        {
          staticClass: "z_index",
          attrs: {
            prop: "z_index",
            rules: [
              {
                required: true,
                pattern: /^(?:[1-9]|[1-9][0-9])$/,
                message: "请输入1-99之间的整数！",
              },
            ],
          },
        },
        [
          _c("div", [_vm._v(" 层级高度值 ")]),
          _c("el-input", {
            attrs: { placeholder: "请输入层级高度值", clearable: "" },
            model: {
              value: _vm.value.config.z_index,
              callback: function ($$v) {
                _vm.$set(_vm.value.config, "z_index", _vm._n($$v))
              },
              expression: "value.config.z_index",
            },
          }),
        ],
        1
      ),
      _vm.showPictureLibrary
        ? _c("picture-library", {
            attrs: {
              configData: _vm.value,
              pictureList: _vm.pictureList,
              depot: _vm.depot,
            },
            on: {
              onClose: function ($event) {
                _vm.showPictureLibrary = false
              },
              onSubmit: _vm.onChangePic,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }